import React, { useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

import Input from '../../UI/Input';

import classes from './JoinAndNumGuests.module.css';

const JoinAndNumGuests = ({iAmIn, numberOfGuests, onChange}) => {
  const [imIn, setImIn] = useState(iAmIn);
  const [numGuests, setNumGuests] = useState(numberOfGuests);
// debugger
  const handleImInChange = (joinEvent) => {
    setImIn(joinEvent)
    onChange(joinEvent, numGuests)
  }

  const handleNumUsershange = (event) => {
    if (event.target.value.trim() === '') {
      setNumGuests(null)
      return;
    }

    let numberGuests = Number(event.target.value);
    if (numberGuests < 0) {
      numberGuests = 0;
    }
    setNumGuests(numberGuests)
    onChange(imIn, numberGuests)
  }

  return (
    <div className={classes.InlineJoinForm}>
      <InputGroup>
        <div>I'm attending too?</div>
        <Form.Label className={classes.Radio} htmlFor='im_in_true'>YES</Form.Label>
        <Form.Check
          type='radio'
          as='input'
          id="im_in_true"
          className={classes.Radio}
          checked={imIn === true}
          value={true}
          name='im_in_true'
          onChange={() => {handleImInChange(true)}}
        />
        <Form.Label className={classes.Radio} htmlFor='send_notifications_false'>NO</Form.Label>
        <Form.Check
          styles={[{marginLeft: 20}]}
          type='radio'
          as='input'
          id="im_in_false"
          className={classes.Radio}
          checked={imIn === false}
          value={false}
          name='im_in_false'
          onChange={() => {handleImInChange(false)}}
        />
      </InputGroup>

      <div>
        Number of guests attending.&nbsp;
        <Input 
          type="number"
          min="0" 
          max="20" 
          noPrepend 
          noInputGroup
          value={numGuests} 
          changed={(e) => handleNumUsershange(e)}
          style={{width: '70px', display:'inline-block'}}
        />
      </div>
    </div>
);
}

export default JoinAndNumGuests;